export function not(source) {
  return source.map(value => !value);
}